import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntHereinnahme: SelectDataObject[] = [
    { i: 0, t: 'keine' },
    { i: 1, t: 'Leasing' },
    { i: 2, t: 'Jahreswagen' },
    { i: 3, t: 'Geschäftsfahrzeug' },
    { i: 4, t: 'Werksdienstwagen Audi' },
    { i: 5, t: 'Geschäftsfahrzeug VW' },
    { i: 6, t: 'Inzahlungnahme auf NW' },
    { i: 7, t: 'Inzahlungnahme auf GW' },
    { i: 8, t: 'Zukauf Sonstige' },
    { i: 9, t: 'Vorführwagen' },
    { i: 10, t: 'Euromobil' },
    { i: 11, t: 'Mietwagen' },
    { i: 12, t: 'Tradeport' },
    { i: 13, t: 'Schrott' },
    { i: 14, t: 'Inz.-nahme auf Differenzbesteuert' },
    { i: 15, t: 'Inz.-nahme auf Regelbesteuert' },
    { i: 16, t: 'Zukauf Differenzbesteuert' },
    { i: 18, t: 'Geschäftswagen VW' },
    { i: 19, t: 'Zukauf Regelbesteuert' },
    { i: 21, t: 'Geschäftswagen VW' },
    { i: 22, t: 'Agenturg. mit Gegengeschäft' },
    { i: 23, t: 'Agenturg. ohne Gegengeschäft' },
    { i: 24, t: 'Sonderzukauf' },
    { i: 25, t: 'Tageszulassung' },
    { i: 26, t: 'Buy back / Plus 3' },
    { i: 27, t: 'Auktion' },
    { i: 28, t: 'Wandlung' },
    { i: 29, t: 'Inzahlungnahme auf GW VW PKW' },
    { i: 30, t: 'Inzahlungnahme auf GW Audi' },
    { i: 31, t: 'Inzahlungnahme auf GW Fremdfabrikate' },
    { i: 32, t: 'Fremdleasing VW PKW' },
    { i: 33, t: 'Gebrauchtwagen VW-NFZ' },
    { i: 34, t: 'Gebrauchtwagen Fremde NFZ' },
    { i: 35, t: 'Fremdleasing Nutzfahrzeuge' },
    { i: 36, t: 'Vorführwagen VW-PKW' },
    { i: 37, t: 'Vorführwagen AU-PKW' },
    { i: 38, t: 'Fremdleasing Audi PKW' },
    { i: 39, t: 'Vorführwagen VW-NFZ' },
    { i: 40, t: 'Inzahlungnahme auf NW VW PKW' },
    { i: 41, t: 'Inzahlungnahme auf NW Audi' },
    { i: 42, t: 'Inzahlungnahme auf NW Fremdfabrikate' },
    { i: 43, t: 'Zukauf Fremdfabrikate' },
    { i: 44, t: 'Euromobil VW-GW' },
    { i: 45, t: 'Euromobil AU-GW' },
    { i: 46, t: 'Euromobil NF-GW' },
    { i: 47, t: 'Zukauf VW' },
    { i: 48, t: 'Zukauf Audi' },
    { i: 49, t: 'Zukauf NFZ' },
    { i: 50, t: 'VW/Audi Leasing VW PKW' },
    { i: 51, t: 'VW/Audi Leasing Audi PKW' },
    { i: 52, t: 'VW/Audi Leasing Audi NF' },
    { i: 53, t: 'VW/Audi Bank AutoCredit VW + Audi' },
    { i: 54, t: 'VW/Audi Bank VarioCredit NFZ' },
    { i: 55, t: 'Werksdienstwagen SEAT' },
    { i: 56, t: 'Werksdienstwagen Skoda' },
    { i: 57, t: 'Dienstwagen' },
    { i: 59, t: 'Restriktionsfahrzeug' },
    { i: 60, t: 'Polizei' },
    { i: 61, t: 'WA-Rückläufer' },
    { i: 62, t: 'WA-Leasing' },
    { i: 63, t: 'Bastler' },
];
export default sIntHereinnahme;
